import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingIndicatorComponent } from '../../../core/components/loading-indicator/loading-indicator.component';
import { VerticalScrollContainerComponent } from '../../../core/components/vertical-scroll-container/vertical-scroll-container.component';
import { VoicestormPosts, VoicestormPublication } from '../../models';
import { VoicestormLatest } from '../../models/voicestorm-latest.interface';
import { FirstUpService } from '../../services/firstup.service';
import { VoicestormService } from '../../services/voicestorm.service';
import { LatestNewsItemComponent } from './latest-news-item/latest-news-item.component';

@Component({
  selector: 'app-latest-news',
  standalone: true,
  imports: [
    LatestNewsItemComponent,
    VerticalScrollContainerComponent,
    LoadingIndicatorComponent
  ],
  templateUrl: './latest-news.component.html',
  styleUrl: './latest-news.component.scss'
})
export class LatestNewsComponent implements OnInit {
  items: VoicestormLatest[] = [];
  isLoading = false;
  loadingMessage = 'Loading latest news...';
  constructor(private voicestormService: VoicestormService, private firstUpService: FirstUpService) {

  }

  ngOnInit(): void {
    this.loadLatestNews();
  }
  //loadLatestNews(): void {
  //  this.isLoading = true;
  //  this.voicestormService.getLatestNews()
  //    .pipe(finalize(() => this.isLoading = false))
  //    .subscribe((data: VoicestormPosts<VoicestormLatest>) => {
  //      this.items = data.posts;
  //    });
  //  this.voicestormService.getLatestPublications()
  //    .pipe(finalize(() => this.isLoading = false))
  //    .subscribe((data: VoicestormPosts<VoicestormPublication>) => {
  //      const newItems = data.posts.map(blog => this.mapPublicationToLatest(blog));
  //      this.items.push(...newItems);
  //      newItems.sort((a, b) => {
  //        const dateA = new Date(a.publishDate).getTime();
  //        const dateB = new Date(b.publishDate).getTime();
  //        return dateB - dateA;
  //      });
  //      this.items = newItems.slice(0, 10);
  //    });
  //}

  loadLatestNews(): void {
    this.isLoading = true;
    this.firstUpService.getLatestNews(10)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (data: VoicestormPosts<VoicestormLatest>) => {
          // Sort by publish date (newest first)
          this.items = data.posts.sort((a, b) => {
            const dateA = new Date(a.publishDate).getTime();
            const dateB = new Date(b.publishDate).getTime();
            return dateB - dateA;
          });
        },
        error: (error) => {
          console.error('Error loading FirstUp news:', error);
          this.items = [];
        }
      });
  }

  private mapPublicationToLatest(publication: VoicestormPublication): VoicestormLatest {
    return {
      title: publication.title,
      author: publication.author,
      boxImage: publication.imageUrl,
      link: publication.articleLink,
      publishDate: publication.publishDate,
      squareImage: publication.imageUrl,
      postId: ""
    };
  }
  scrollUp(): void {
    const content = document.querySelector('.latestnews-scroller');
    content?.scrollBy({
      top: -100,
      behavior: 'smooth'
    });
  }

  scrollDown(): void {
    const content = document.querySelector('.latestnews-scroller');
    content?.scrollBy({
      top: 100,
      behavior: 'smooth'
    });
  }
}
